import { create } from 'zustand';

/**
 * Global sidebar state management
 * Handles both desktop collapse and mobile drawer states
 */
export const useSidebarToggle = create((set) => ({
  // Desktop: collapsed state
  isCollapsed: false,
  toggleCollapsed: () => set((state) => ({ isCollapsed: !state.isCollapsed })),
  
  // Mobile: drawer open state
  isMobileOpen: false,
  openMobile: () => set({ isMobileOpen: true }),
  closeMobile: () => set({ isMobileOpen: false }),
  toggleMobile: () => set((state) => ({ isMobileOpen: !state.isMobileOpen })),
}));
